import { render, staticRenderFns } from "./VueModal.vue?vue&type=template&id=fe406f9c&scoped=true&"
import script from "./VueModal.vue?vue&type=script&lang=js&"
export * from "./VueModal.vue?vue&type=script&lang=js&"
import style0 from "./VueModal.vue?vue&type=style&index=0&id=fe406f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe406f9c",
  null
  
)

export default component.exports